const PASSWORD = "Director3";
const SESSION_COOKIE = "kebatic_session";
const PREFS_COOKIE = "kebatic_prefs";
const SESSION_MAX_AGE = 365 * 24 * 60 * 60;

const setCookie = (name, value, maxAge) => {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
};

const getCookie = name => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const login = (name, password) => {
  if (password !== PASSWORD || !name.trim()) return false;
  const session = btoa(JSON.stringify({ name: name.trim() }));
  setCookie(SESSION_COOKIE, session, SESSION_MAX_AGE);
  return true;
};

export const logout = () => {
  setCookie(SESSION_COOKIE, "", 0);
};

export const getSession = () => {
  const raw = getCookie(SESSION_COOKIE);
  if (!raw) return null;
  try {
    const { name } = JSON.parse(atob(raw));
    return name ? { name } : null;
  } catch {
    return null;
  }
};

const prefsKey = userName => userName.trim().toLowerCase();

const readAllPrefs = () => {
  const raw = getCookie(PREFS_COOKIE);
  if (!raw) return {};
  try {
    return JSON.parse(atob(raw)) || {};
  } catch {
    return {};
  }
};

export const getKebabPrefs = userName => {
  if (!userName?.trim()) return null;
  const prefs = readAllPrefs()[prefsKey(userName)];
  if (!prefs || typeof prefs !== "object") return null;
  return {
    size: prefs.size || "",
    type: prefs.type || "",
    sauces: Array.isArray(prefs.sauces) ? prefs.sauces : [],
  };
};

export const saveKebabPrefs = (userName, { size, type, sauces }) => {
  if (!userName?.trim()) return;
  const all = readAllPrefs();
  all[prefsKey(userName)] = {
    size: size || "",
    type: type || "",
    sauces: Array.isArray(sauces) ? sauces : [],
  };
  setCookie(PREFS_COOKIE, btoa(JSON.stringify(all)), SESSION_MAX_AGE);
};
